<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1">
<div class="chapterHead"><p class="centerImage3"><img alt="image" src="images/ch2.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">“What?” Gabe asks, looking interested.</p>
<p class="para" style="text-indent: 5%;">“There <em class="italic">is</em> something else in the can,” you answer. You reach in and pull out a small plastic packet that was stuck to the inside. It looks like a ketchup packet.</p>
<p class="para" style="text-indent: 5%;">“What is it?” Gabe moves closer.</p>
<p class="para" style="text-indent: 5%;">“I think it’s fake blood,” you tell him.</p>
<p class="para" style="text-indent: 5%;">“Really? Cool,” Gabe says. He picks up the Vampire in a Can box and reads the label. “That’s weird. It doesn’t say anything on the box about fake blood.”</p>
<p class="para" style="text-indent: 5%;">Then you notice the writing on the packet.</p>
<p class="para" style="text-indent: 5%;">In bloodred letters, it says, <span class="smallCaps">DANGER — KEEP AWAY</span>.</p>
<p class="para" style="text-indent: 5%;">You hand the packet to Gabe. He reads the label and his eyes grow wide. “Are you going to open it?” he asks.</p>
<p class="para" style="text-indent: 5%;">You gulp. The words on the packet are kind of scary.</p>
<p class="para" style="text-indent: 5%;">But you’re <em class="italic">dying</em> to know what’s inside.</p>
<p class="para" style="text-indent: 5%;">So? Are you going to open it?</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">If you open the packet, turn to <span href="#/e9780545820660_ch034" title="Link target outside of Sample">PAGE 34</span>.</em></p>
<p class="para" style="text-indent: 5%;"><em class="italic">If you don’t open it, turn to <span href="#/e9780545820660_ch067" title="Link target outside of Sample">PAGE 67</span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545820660_ch002.vue?5727195a